import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CqQasService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/cq-qas', query);
  }

  create(body: any) {
    return this.post('/cq-qas', body);
  }

  find(id) {
    return this.get('/cq-qas/' + id);
  }

  update(id, body) {
    return this.put('/cq-qas/' + id, body);
  }

  allCqQas(query?: any) {
    return this.get('/cq-qas', query);
  }

  _delete(id) {
    return this.delete('/cq-qas/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/CqQas.service.ts